import { Component } from 'js-component-framework';

/**
 * LoadMore Class
 * Handles loading additional posts on demand.
 */
export default class LoadMore extends Component {
  /**
   * Start the component
   * @param {Object} config
   */
  constructor(config) {
    super(config);
    this.loadMoreButton = document.querySelector(config.querySelector.loadMoreButton);
    this.postList = document.querySelector(config.querySelector.postList);

    // Initialize the load more functionality
    if (this.loadMoreButton && this.postList) {
      this.initLoadMore();
    }
  }

  /**
   * Adds event listener to load more button and triggers fetching new content.
   */
  initLoadMore() {
    this.loadMoreButton.setAttribute('role', 'button');
    this.loadMoreButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.loadPosts(e.target);
    });
  }

  /**
   * Fetches the next page of results and appends them to the post list.
   * @param {HTMLElement} target
   */
  loadPosts(target) {
    const url = target.getAttribute('href');

    // Fetch the next page of results.
    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = data;

        // Inject new posts.
        const newPosts = tempDiv.querySelectorAll('.post-list > *');
        newPosts.forEach((post) => {
          this.postList.appendChild(post);
        });

        // Copy the new load more URL into the existing link.
        const newLoadMoreButton = tempDiv.querySelector('.load-more--is-available a');
        if (newLoadMoreButton) {
          const currentLoadMoreButton = target.closest('.load-more--is-available a');
          if (currentLoadMoreButton) {
            currentLoadMoreButton.setAttribute('href', newLoadMoreButton.getAttribute('href'));
          }
        }
      })
      .catch(() => {
      });
  }
}
